"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpinnerButton = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
exports.SpinnerButton = React.memo(function (props) {
    var isButtonDisabled = props.isButtonDisabled, iconRight = props.iconRight, className = props.className, color = props.color, shouldDisplaySpinner = props.shouldDisplaySpinner, buttonText = props.buttonText, handleOnClick = props.handleOnClick;
    if (shouldDisplaySpinner) {
        return (React.createElement(sok_ui_1.Button, { size: 'medium', className: "fetch-loading" },
            React.createElement(sok_ui_1.LoadingSpinner, null)));
    }
    return (React.createElement(sok_ui_1.Button, { disabled: isButtonDisabled, iconRight: iconRight, className: className, color: color, size: 'medium', text: buttonText, onClick: handleOnClick }));
});
